// extracted by mini-css-extract-plugin
export var layoutContainer = "_cu-0";
export var layoutContainerNoRounding = "_cu-6";
export var layoutContainerOpen = "_cu-5";
export var layoutContainerResizing = "_cu-1";
export var mainContent = "_cu-2";
export var resizeDivider = "_cu-3";
export var slidePanel = "_cu-4";